import styled from "styled-components"
import { useGSAP } from "@gsap/react"
import { useRef } from "react"
import { gsap, ScrollTrigger } from "@/utils/gsap"
import { getCssSizeValue } from "@/utils/utils"
import FallingCrossSvg from "@/components/common/Icon/SVGR/FallingCross"
import { BREAKPOINTS } from "@/styles/themeSettings"
import useDevice from "@/hooks/useDevice"
import useResponsiveValues from "@/hooks/useResponsiveValues"

const Wrapper = styled.div`
	position: absolute;
	top: ${getCssSizeValue(50, BREAKPOINTS.MOBILE)};
	right: var(--paddingX);
	--size: ${getCssSizeValue(74, BREAKPOINTS.MOBILE)};
	height: var(--size);
	width: var(--size);

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		--size: ${getCssSizeValue(170, BREAKPOINTS.TABLET)};
		right: 6vw;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(40)} 0;
		--size: ${getCssSizeValue(180)};
		right: 16vw;
	}

	.cross-svg {
		transform: scale(0);
	}
`

export default function FallingCross() {
	const { isDesktop, isTablet, isMobile } = useDevice()
	const ref = useRef()

	const [responsiveMobileFallValue, responsiveTabletFallValue, responsiveDesktopFallValue] = useResponsiveValues([750, 750, 600])

	useGSAP(() => {
		if (!ref.current || responsiveDesktopFallValue === 0 || responsiveMobileFallValue === 0 || responsiveMobileFallValue === 0) return
		if (!isMobile) {
			const tl = gsap.timeline({ paused: true })

			tl.set(".cross-svg", {
				rotation: -65,
			})
				.to(".cross-svg", {
					rotation: 0,
					scale: 1,
					transformOrigin: "center center",
					delay: 0.8,
				})
				.to(".cross-svg", {
					y: -50,
					duration: 0.6,
				})
				.to(".cross-svg", {
					y: isDesktop ? responsiveDesktopFallValue : isTablet ? responsiveTabletFallValue : responsiveMobileFallValue,
					scale: 0,
					duration: 0.5,
					ease: "none",
				})

			tl.play()
		} else {
			const revealTl = gsap.timeline({ paused: true })
			const fallTl = gsap.timeline({ paused: true })

			revealTl
				.set(".cross-svg", {
					rotation: -60,
				})
				.to(".cross-svg", {
					rotation: 0,
					scale: 1,
					transformOrigin: "center center",
					delay: 0.8,
				})

			fallTl
				.to(".cross-svg", {
					y: -50,
					duration: 0.6,
				})
				.to(".cross-svg", {
					y: isDesktop ? responsiveDesktopFallValue : isTablet ? responsiveTabletFallValue : responsiveMobileFallValue,
					scale: 0,
					duration: 0.5,
					ease: "none",
				})

			revealTl.play()

			ScrollTrigger.create({
				trigger: ".cross-svg",
				start: `top top+=140`,
				animation: fallTl,
				invalidateOnRefresh: true,
			})
		}
	}, [responsiveDesktopFallValue, responsiveTabletFallValue, responsiveMobileFallValue, isMobile])

	return (
		<Wrapper ref={ref}>
			<FallingCrossSvg className="cross-svg" />
		</Wrapper>
	)
}
